module.exports = __webpack_public_path__ + "img/album17_10.74cf9170.jpg";